licenses-notices-1 = BestCraft is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General Public License as published by the Free Software Foundation, either version 3 of the License, or (at your option) any later version.
licenses-notices-2 = BestCraft is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more details.
licenses-notices-3 = You should have received a copy of the GNU Affero General Public License along with BestCraft. If not, see https://www.gnu.org/licenses/.
copyright-notices =
    Copyright 2026 Tnze. All Rights Reserved.
    Referenced FFXIV related resources: Copyright © 2010 - 2026 SQUARE ENIX CO., LTD.

level = Lv.
recipe-level = Recipe Lv.
class-job-level = Class Job Lv.
craftsmanship = Craftsmanship
control = Control
craft-point = CP
progress = Progress
quality = Quality
durability = Durability
steps = Step
condition = Condition
difficulty = Difficulty
initial-quality = Quality
conditions = Cond. Flag
progress-divider = Progress Divider
progress-modifier = Progress Modifier
quality-divider = Quality Divider
quality-modifier = Quality Modifier
difficulty-factor = Difficulty Factor
quality-factor = Quality Factor
durability-factor = Durability Factor
material-quality-factor = Material Quality Factor

meals = Meals
medicines = Medicines

name = Name
amount = Amount

specialist = Specialist

# Job names
carpenter = Carpenter
blacksmith = Blacksmith
armorer = Armorer
goldsmith = Goldsmith
leatherworker = Leatherworker
weaver = Weaver
alchemist = Alchemist
culinarian = Culinarian


# Gearset names
default = Default
common = Common
custom = Custom { $id }

# Action names
basic-synthesis = Basic Synthesis
basic-touch = Basic Touch
masters-mend = Master's Mend
hasty-touch = Hasty Touch
rapid-synthesis = Rapid Synthesis
observe = Observe
tricks-of-the-trade = Tricks of the Trade
waste-not = Waste Not
veneration = Veneration
standard-touch = Standard Touch
great-strides = Great Strides
innovation = Innovation
final-appraisal = Final Appraisal
waste-not-ii = Waste Not II
byregot-s-blessing = Byregot's Blessing
precise-touch = Precise Touch
muscle-memory = Muscle Memory
careful-synthesis = Careful Synthesis
manipulation = Manipulation
prudent-touch = Prudent Touch
reflect = Reflect
preparatory-touch = Preparatory Touch
groundwork = Groundwork
delicate-synthesis = Delicate Synthesis
intensive-synthesis = Intensive Synthesis
trained-eye = Trained Eye
advanced-touch = Advanced Touch
prudent-synthesis = Prudent Synthesis
trained-finesse = Trained Finesse
careful-observation = Careful Observation
heart-and-soul = Heart and Soul
refined-touch = Refined Touch
daring-touch = Daring Touch
immaculate-mend = Immaculate Mend
quick-innovation = Quick Innovation
trained-perfection = Trained Perfection
stellar-steady-hand = Stellar Steady Hand

# Action descriptions
desc-basic-synthesis = Increases progress. Efficiency: 100 (120 after Lv.31).
desc-basic-touch = Increases quality. Efficiency: 100.
desc-masters-mend = Restores 30 durability.
desc-hasty-touch = Increases quality. Efficiency: 100, costs no CP, success rate: 60%.
desc-rapid-synthesis = Increases progress. Efficiency: 250 (500 after Lv.63), success rate: 50%.
desc-observe = Skips a turn. Used to combo Focused Synthesis and Focused Touch.
desc-tricks-of-the-trade = Restores 20 CP. Only available when condition is Good or Excellent.
desc-waste-not = Reduces durability loss by 50% for the next 4 steps.
desc-veneration = Increases the efficiency of progress actions by 50% for the next 4 steps.
desc-standard-touch = Increases quality. Efficiency: 125. Combo with Basic Touch reduces CP cost.
desc-great-strides = Doubles the efficiency of the next touch action. Active for 3 steps.
desc-innovation = Increases the efficiency of quality actions by 50% for the next 4 steps.
desc-final-appraisal = Stops progress just before completion when using a progress action. Active for 5 steps.
desc-waste-not-ii = Reduces durability loss by 50% for the next 8 steps.
desc-byregot-s-blessing = Consumes Inner Quiet stacks to increase quality. Efficiency 100~300, +20 per stack.
desc-precise-touch = Increases quality. Efficiency: 150, grants 2 stacks of Inner Quiet. Only available when condition is Good or Excellent.
desc-muscle-memory = Only available on the first step. Increases progress. Efficiency: 300. Doubles the effect of the next progress action. Active for 5 steps.
desc-careful-synthesis = Increases progress. Efficiency: 150 (180 after Lv.82).
desc-manipulation = Restores 5 durability after each step for the next 8 steps.
desc-prudent-touch = Increases quality. Efficiency: 100, costs only 5 durability. Cannot be used under Waste Not.
desc-reflect = Only available on the first step. Increases quality. Efficiency: 300, grants 2 stacks of Inner Quiet.
desc-preparatory-touch = Increases quality. Efficiency: 200, grants 2 stacks of Inner Quiet, costs 20 durability.
desc-groundwork = Increases progress. Efficiency: 300 (360 after Lv.86), costs 20 durability. Efficiency halved when durability is insufficient.
desc-delicate-synthesis = Increases progress and quality. Efficiency: 100 (progress efficiency 150 after Lv.94).
desc-intensive-synthesis = Increases progress. Efficiency: 400. Only available when condition is Good or Excellent.
desc-trained-eye = Only available on the first step when recipe level is 10+ levels lower. Increases quality by 100% of maximum.
desc-advanced-touch = Increases quality. Efficiency: 150. Combo with Standard Touch reduces CP cost.
desc-prudent-synthesis = Increases progress. Efficiency: 180, costs only 5 durability. Cannot be used under Waste Not.
desc-trained-finesse = Only available with 10 stacks of Inner Quiet. Increases quality. Efficiency: 100, costs no durability.
desc-careful-observation = Consumes 1 Crafter's Delineation to change condition. Up to 3 uses per craft. Simulator UI does not currently support condition switching.
desc-heart-and-soul = Consumes 1 Crafter's Delineation to allow one use of Precise Touch, Intensive Synthesis, or Tricks of the Trade. Up to 1 use per craft.
desc-refined-touch = Increases quality. Efficiency: 100. Combo with Basic Touch grants an additional stack of Inner Quiet.
desc-daring-touch = Increases quality. Efficiency: 150, costs no CP, success rate: 60%.
desc-immaculate-mend = Restores durability to maximum.
desc-quick-innovation = Grants Innovation status. Lasts 1 step. Up to 1 use per craft.
desc-trained-perfection = The next action that consumes durability will cost 0 durability. Up to 1 use per craft.
desc-stellar-steady-hand = Guarantees the next action will succeed. Active for 3 steps.

DurabilityNotEnough = Durability not enough
CraftPointNotEnough = Craft point not enough
CraftingAlreadyFinished = Crafting already finished
PlayerLevelTooLow = Player level too low
RequireGoodOrExcellent = Require good or excellent
NotAllowedInWastNotBuff = Not allowed in wast not buff
OnlyAllowedInFirstStep = Only allowed in first step
LevelGapMustGreaterThanTen = Level gap must greater than 10
RequireInnerQuiet1 = Require at least 1 stack of inner quiet
RequireInnerQuiet10 = Require 10 stack of inner quiet
CarefulObservationUsed3 = Careful observation can only use 3 times
HeartAndSoulUsed = Heart and soul can be only used once
FocusNeverFailsAfterObserved = Focus never fails after observed
RequireHastyTouchSuccessed = Require hasty touch successed first
QuickInnovationUsed = Quick innovation can be only used once
NotAllowedInInnovationBuff = Not allowed in innovation buff
TrainedPerfectionUsed = Trained perfection can be only used once

# Conditions
normal = Normal
good = Good
excellent = Excellent
poor = Poor
centered = Centered
sturdy = Sturdy
pliant = Pliant
malleable = Malleable
primed = Primed
goodomen = Good Omen
robust = Robust

# Updater
update-available = Update Available: v{ $version }
update-now = Update Now
update-not-now = Not Now
update-installing = Updating in progress, please wait patiently.
update-ask-relaunch = Update installed, relaunch?

update-pending = Updating in progress
update-error = Update failed: { $error }
update-done = Update done
update-uptodate = Up-to-date

update-started = Download update started
update-progress = Download update in progress: { $progress }
update-done = Download update finished

# Rust Errors
player-level-lower-than-recipe-requirement = Player level is lower than the recipe's requirement.
unknown-recipe-level = Unknown recipe level
solver-already-exist = Solver is already exist
solver-is-creating = Solver is already creating
solver-doesn-t-exist = Solver doesn't exist
solver-isn-t-prepared = Solver isn't prepared

# Titles
attributes = Crafter Attributes
select-recipe = Search Recipe
custom-recipe = Custom Recipe
bill-of-material = Bill of Material
settings = Settings
title = { $recipe } (Simulator Mode)

# Solvers
dp-solver = DP
raphael-solver = Raphael
bfs-solver = BFS
dfs-solver = DFS
